//apiUrl & webSiteUrl  配置文件 配置内容待完善
const url = [
  {
    //正式环境
    web: 'https://m.ceekee.com/',
    baseApi: 'https://api.ceekeeapi.com/tripwise/',
    plantId: '1020',
  },
  {
    //对外联调测试环境
    web: 'https://outfatm.ceekee.com/',
    baseApi: 'https://outfat.ceekeeapi.com/tripwise/',
    plantId: '1020',
  },
  {
    //微信测试
    web: 'https://testweixin.ceekee.com/',
    baseApi: 'https://fat.ceekeeapi.com/tripwise/',
    plantId: '1033',
  },
  {
    //钉钉测试 自建
    web: 'https://testdingding.ceekee.com/',
    baseApi: 'https://api.ceekeeapi.com/testdingding/',
    plantId: '1028',
  },
  {
    //钉钉服务商
    web: 'https://dingding.ceekee.com/',
    baseApi: 'https://api.ceekeeapi.com/tripwise/',
    // plantId: '1020', //app
    plantId: '1028', //钉钉
    refId: '153',
  },
  {
    //微信
    web: 'https://sweixin.ceekee.com/',
    baseApi: 'https://api.ceekeeapi.com/tripwise/',
    plantId: '1033',
  },
  {
    //嵌入分销平台
    web: 'https://distribution.ceekee.com/',
    baseApi: 'https://api.ceekeeapi.com/tripwise/',
    plantId: '1035',
  },
  {
    // 迈为  47.102.141.120
    web: 'https://newmaiwei.ceekee.com/',
    baseApi: 'https://api.ceekeeapi.com/maiwei/',
    plantId: '1028',
  },
  {
    // 测试环境
    web: 'https://fatm.ceekee.com/',
    baseApi: 'https://fat.ceekeeapi.com/tripwise/',
    plantId: '1020',
  },
  {
    // 预发环境
    web: 'https://uatm.ceekee.com/',
    baseApi: 'https://uat.ceekeeapi.com/tripwise/',
    plantId: '1020',
  },
  {
    // 华为云测试环境
    web: 'https://hwytest.ceekeeapi.com/',
    baseApi: 'https://hwytest.ceekeeapi.com/tripwise/',
    plantId: '1020',
  },
  {
    // 对外预发环境
    web: 'https://outuatm.ceekee.com/',
    baseApi: 'https://uat.ceekeeapi.com/tripwise/',
    plantId: '1080',
  },
  {
    // 钉钉预发环境
    web: 'https://dingdinguatm.ceekee.com/',
    baseApi: 'https://api.ceekeeapi.com/tripwise/',
    plantId: '1028',
  },
  {
    //飞书
    web: 'https://feishu.ceekee.com/',
    baseApi: 'https://api.ceekeeapi.com/tripwise/',
    plantId: '1040',
  },
  {
    //分销
    web: 'https://d.ceekee.com/',
    baseApi: 'https://api.ceekeeapi.com/tripwise/',
    plantId: '1005',
  },
  {
    //企业微信预发环境
    web: 'https://uatweixin.ceekee.com/',
    baseApi: 'https://uat.ceekeeapi.com/tripwise/',
    plantId: '1033',
  },
  {
    //广东中旅
    web: 'https://mtrip.gdcts.com/',
    baseApi: 'https://api.ceekeeapi.com/tripwise/',
    plantId: '1080',
  },
];

module.exports = {
  url,
};
